import { UserContext } from '../../context';
import UserInfoTooltip from '../UserInfoTooltip';

const UserTooltipProvider: React.FC<{ userId: string; children: React.ReactElement<any, any> }> = ({
  userId,
  children,
}) => {
  return (
    <UserContext.Provider
      value={{
        user: {
          id: userId,
        },
      }}>
      <UserInfoTooltip isUserInfoTooltipEnabled>{children}</UserInfoTooltip>
    </UserContext.Provider>
  );
};

export default UserTooltipProvider;
